/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/ 		if(executeModules) {
/******/ 			for(i=0; i < executeModules.length; i++) {
/******/ 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
/******/ 			}
/******/ 		}
/******/ 		return result;
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		9: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 19);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ACCOUNTBASE = "//price.wuheung.com/";
var LOGINURLBASE = "//price.wuheung.com/";
var BASEURL = "//price.wuheung.com/";
// var BASEURL = "http://192.168.10.106:48080";
var CREURL = "//price.wuheung.com/";
// var ACCOUNTBASE = "";
// var LOGINURLBASE = "";
// var BASEURL = "";
// var CREURL = "";

// if (window.location.hostname.includes('localhost')|| window.location.hostname.includes('kemai.com')) {
//   ACCOUNTBASE = "//saasAdmin.kemai.com:8010";
//   LOGINURLBASE = "//account.kemai.com:8010";
//   BASEURL = "//www.kemai.com:8010";
//   CREURL = "//service.kemai.com:8010";
// }else if(window.location.hostname.includes('test.gitbo.cn')){
//   ACCOUNTBASE = "//saasAdmin.test.gitbo.cn";
//   LOGINURLBASE = "//account.test.gitbo.cn";
//   BASEURL = "//www.test.gitbo.cn";
//   CREURL = "//service.test.gitbo.cn";
// }else if(window.location.hostname.includes('codeji.cn')){
//   ACCOUNTBASE = "//saasAdmin.codeji.cn:8010";
//   LOGINURLBASE = "//account.codeji.cn:8010";
//   BASEURL = "//www.codeji.cn:8010";
//   CREURL = "//service.codeji.cn:8010";
// }

exports.ACCOUNTBASE = ACCOUNTBASE;
exports.LOGINURLBASE = LOGINURLBASE;
exports.BASEURL = BASEURL;
exports.CREURL = CREURL;

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(21);

__webpack_require__(22);

__webpack_require__(23);

__webpack_require__(24);

__webpack_require__(25);

__webpack_require__(26);

__webpack_require__(27);

__webpack_require__(28);

__webpack_require__(29);

__webpack_require__(30);

__webpack_require__(31);

__webpack_require__(32);

var _api = __webpack_require__(0);

(function () {

  var commonFunction = {
    switchToke: function switchToke(that, Element, targetElement, activeElement, switchElement) {
      $('.' + targetElement + ' div').removeClass(activeElement);
      $('.triangle').remove();
      that.addClass(activeElement);
      $('.' + activeElement).parent()[0].appendChild(Element);
      refreshClue(that, switchElement);
    }

    //拓客线索的切换的内容函数
  };function refreshClue(Elem, switchElement) {
    //Elem传递的是点击的div
    if (Elem[0].id == 'clue1') {
      $('.' + switchElement + ' > div').css('display', 'none');
      $('.' + switchElement + ' > div:nth-child(1)').css('display', 'block');
    } else if (Elem[0].id == 'clue2') {
      $('.' + switchElement + ' > div').css('display', 'none');
      $('.' + switchElement + ' > div:nth-child(2)').css('display', 'block');
    } else if (Elem[0].id == 'clue3') {
      $('.' + switchElement + ' > div').css('display', 'none');
      $('.' + switchElement + ' > div:nth-child(3)').css('display', 'block');
    } else if (Elem[0].id == 'clue4') {
      $('.' + switchElement + ' > div').css('display', 'none');
      $('.' + switchElement + ' > div:nth-child(4)').css('display', 'block');
    }
  }

  $(".jump-link").click(function () {
    window.open('' + _api.LOGINURLBASE, "_blank");
  });

  var autoAnimation = {
    visiable: false,
    exitVisable: false, //确认不在浏览器显示屏中
    getTimeOut: function getTimeOut(time, element, sumElement) {
      var timeSpeed = 10; //默认的每100ms变化一次
      var changeSum = time / 10; //一个轮回变化的次数
      var numberArr = []; // 暂存所有dom的现在的值和最大值的数组

      // 遍历dom，拿值
      element.forEach(function (item) {
        numberArr.push({
          now: 0,
          max: item.attr("sum")
        });
      });

      // 延迟动画
      if ($(sumElement).attr("sum-arry") === "join") {
        element.forEach(function (item, index) {
          setTime(item);
        });
      }

      function setTime(item) {
        $('#' + item.attr("id")).countUp();
      }

      //   function setTime(element2, index) {
      //     // 当前dom最大值
      //     var subMax = numberArr[index].max;
      //     // 当前dom增加速度
      //     var speed = numberArr[index].max / changeSum;

      //     setTimeout(()=>{
      //       // 设置现在的值
      //       numberArr[index].now += speed;
      //       // 当现在的值小于最大值，就赋值dom的值并继续动画
      //       if(numberArr[index].now < subMax){
      //         element2.text(Math.floor(numberArr[index].now));
      //         setTime(element2, index);
      //       // 当现在的值大于等于最大值，就
      //       } else{
      //         // 赋值dom的值为最大值
      //         element2.text(subMax);
      //         // 赋值当前最小值为最大值
      //         numberArr[index].now = subMax;
      //         // 检测是否所有都到了最大值
      //         var isAllMax = true
      //         numberArr.forEach((item) => {
      //           if(item.now !== item.max){
      //             isAllMax = false;

      //           }
      //         })
      //         // 如果都到所有都到了最大值就重新开始
      //         if (isAllMax) {
      //           // autoAnimation.visiable = false;
      //           // console.log('>>kkkkk',autoAnimation);
      //           // autoAnimation.getTimeOut(countTime, time, element);
      //         }
      //       }
      //     }, timeSpeed); 
      //   }
    }
  };
  window.animateTimeOut = autoAnimation;

  var onScrollElement = {
    sumArray: [],
    // clientHeight: null,//页面的可视高度
    elementArry: [], //存放所有有sum-arry属性，处理后的元素
    dataHandle: function dataHandle() {
      var sumArray = $('*[sum-arry]');
      onScrollElement.sumArray = sumArray;
      sumArray.map(function (item) {
        var sumElement = sumArray[item]; //每项元素
        var sumElementPosition = sumElement.offsetTop; //每项元素的位置
        var sumHeight = sumElement.offsetHeight; //每项元素的高度
        var elementObj = {
          sumElement: sumElement,
          sumElementPosition: sumElementPosition,
          sumHeight: sumHeight
        };
        onScrollElement.elementArry.push(elementObj);
      });
    },
    onScrollAuto: function onScrollAuto(elementItem, clientHeight) {
      var scrollTop = $(document).scrollTop(); //当前页面的滚动高度
      var sumElement = elementItem.sumElement;
      var sumElementPosition = elementItem.sumElementPosition;
      var sumHeight = elementItem.sumHeight;

      if (sumElementPosition - clientHeight < scrollTop && sumElementPosition + sumHeight > scrollTop) {
        var sumAttribute = $(sumElement).attr("sum-arry");
        if (sumAttribute === "exit") {
          $(sumElement).attr("sum-arry", "join");
          var sumItemArray = $(sumElement).find($("[sum]"));
          var TimeOutArry = [];
          sumItemArray.map(function (i) {
            TimeOutArry.push($(sumItemArray[i]));
          });
          animateTimeOut.getTimeOut(2000, TimeOutArry, sumElement);
        }
      } else {
        $(sumElement).attr("sum-arry", "exit");
      }
    }

    // 页面懒加载
  };var lazyLoad = function lazyLoad(clientHeight) {
    // 获取所有的含有data-src属性的元素
    var imgArray = $('*[data-src]');

    var scrollTop = $(document).scrollTop(); //当前页面的滚动高度
    imgArray.map(function (i) {
      var img = imgArray[i];
      var nowImgHeight = null;
      if ($(img)[0].offsetParent !== 'body') {
        nowImgHeight = $(img)[0].offsetTop;
      } else {
        nowImgHeight = $(img).parent().offsetTop;
      }

      // 如果图片的offestTop在区间内则把data-src的地址赋给src
      if (nowImgHeight - clientHeight - 200 < scrollTop && nowImgHeight + clientHeight + 200 > scrollTop) {
        $(img).context.src = $(img).context.dataset.src;
      } else if (nowImgHeight === 0) {
        $(img).context.src = $(img).context.dataset.src;
      }
    });
  };

  window.commonjs = commonFunction;
  window.lazyLoad = lazyLoad;
  window.onScrollElement = onScrollElement;
})(window);

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$(function () {
  $(".home-chat").click(function () {
    $(".home-suspend-tencent").css("display", "block");
  });

  $(".home-suspend-close").click(function () {
    event.stopPropagation();
    $(".home-suspend-tencent").css("display", "none");
  });

  //展开
  $(".home-chat > span").mouseenter(function () {
    $(".home-chat").addClass("home-chat-active");
  });

  $(".home-chat > span").mouseleave(function () {
    $(".home-chat-active").removeClass("home-chat-active");
  });

  //QQ二维码
  $(".home-suspend-ways > div:nth-child(2)").mouseenter(function () {
    $(".home-suspend-ways > div:nth-child(2) > div").css("display", "block");
  });
  $(".home-suspend-ways > div:nth-child(2)").mouseleave(function () {
    $(".home-suspend-ways > div:nth-child(2) > div").css("display", "none");
  });

  $(".home-suspend-ways > div").on("mouseenter", function () {
    $(".focus").removeClass("focus");
    $(this).addClass("focus");
  });

  $(".home-suspend-ways > div").on("mouseleave", function () {
    $(".focus").removeClass("focus");
  });

  $(".home-suspend-ways > div:nth-child(4)").click(function () {
    $(window).scrollTop(0);
  });

  function draggle() {
    var draggableDiv = document.getElementById("draggable");
    // draggableDiv.style.display = 'none'
    var offsetX, offsetY;
    var isMove = false;

    setTimeout(function () {
      draggableDiv.style.display = "block";
    }, 1000);

    $("#cancel").on("click", function () {
      draggableDiv.style.display = "none";
    });

    $("#contract").on("click", function () {
      draggableDiv.style.display = "block";
    });

    draggableDiv.addEventListener("mousedown", function (event) {
      isMove = true;
      offsetX = event.clientX - draggableDiv.offsetLeft;
      offsetY = event.clientY - draggableDiv.offsetTop;
    });

    document.addEventListener("mousemove", function (event) {
      if (!isMove) {
        return false;
      }
      var x = event.clientX - offsetX;
      var y = event.clientY - offsetY;
      draggableDiv.style.left = x + "px";
      draggableDiv.style.top = y + "px";
    });

    document.addEventListener("mouseup", function () {
      isMove = false;
      offsetX = null;
      offsetY = null;
    });
  }

  draggle();
});

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
Waypoints - 4.0.0
Copyright © 2011-2015 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!function () {
  "use strict";
  function t(o) {
    if (!o) throw new Error("No options passed to Waypoint constructor");if (!o.element) throw new Error("No element option passed to Waypoint constructor");if (!o.handler) throw new Error("No handler option passed to Waypoint constructor");this.key = "waypoint-" + e, this.options = t.Adapter.extend({}, t.defaults, o), this.element = this.options.element, this.adapter = new t.Adapter(this.element), this.callback = o.handler, this.axis = this.options.horizontal ? "horizontal" : "vertical", this.enabled = this.options.enabled, this.triggerPoint = null, this.group = t.Group.findOrCreate({ name: this.options.group, axis: this.axis }), this.context = t.Context.findOrCreateByElement(this.options.context), t.offsetAliases[this.options.offset] && (this.options.offset = t.offsetAliases[this.options.offset]), this.group.add(this), this.context.add(this), i[this.key] = this, e += 1;
  }var e = 0,
      i = {};t.prototype.queueTrigger = function (t) {
    this.group.queueTrigger(this, t);
  }, t.prototype.trigger = function (t) {
    this.enabled && this.callback && this.callback.apply(this, t);
  }, t.prototype.destroy = function () {
    this.context.remove(this), this.group.remove(this), delete i[this.key];
  }, t.prototype.disable = function () {
    return this.enabled = !1, this;
  }, t.prototype.enable = function () {
    return this.context.refresh(), this.enabled = !0, this;
  }, t.prototype.next = function () {
    return this.group.next(this);
  }, t.prototype.previous = function () {
    return this.group.previous(this);
  }, t.invokeAll = function (t) {
    var e = [];for (var o in i) {
      e.push(i[o]);
    }for (var n = 0, r = e.length; r > n; n++) {
      e[n][t]();
    }
  }, t.destroyAll = function () {
    t.invokeAll("destroy");
  }, t.disableAll = function () {
    t.invokeAll("disable");
  }, t.enableAll = function () {
    t.invokeAll("enable");
  }, t.refreshAll = function () {
    t.Context.refreshAll();
  }, t.viewportHeight = function () {
    return window.innerHeight || document.documentElement.clientHeight;
  }, t.viewportWidth = function () {
    return document.documentElement.clientWidth;
  }, t.adapters = [], t.defaults = { context: window, continuous: !0, enabled: !0, group: "default", horizontal: !1, offset: 0 }, t.offsetAliases = { "bottom-in-view": function bottomInView() {
      return this.context.innerHeight() - this.adapter.outerHeight();
    }, "right-in-view": function rightInView() {
      return this.context.innerWidth() - this.adapter.outerWidth();
    } }, window.Waypoint = t;
}(), function () {
  "use strict";
  function t(t) {
    window.setTimeout(t, 1e3 / 60);
  }function e(t) {
    this.element = t, this.Adapter = n.Adapter, this.adapter = new this.Adapter(t), this.key = "waypoint-context-" + i, this.didScroll = !1, this.didResize = !1, this.oldScroll = { x: this.adapter.scrollLeft(), y: this.adapter.scrollTop() }, this.waypoints = { vertical: {}, horizontal: {} }, t.waypointContextKey = this.key, o[t.waypointContextKey] = this, i += 1, this.createThrottledScrollHandler(), this.createThrottledResizeHandler();
  }var i = 0,
      o = {},
      n = window.Waypoint,
      r = window.onload;e.prototype.add = function (t) {
    var e = t.options.horizontal ? "horizontal" : "vertical";this.waypoints[e][t.key] = t, this.refresh();
  }, e.prototype.checkEmpty = function () {
    var t = this.Adapter.isEmptyObject(this.waypoints.horizontal),
        e = this.Adapter.isEmptyObject(this.waypoints.vertical);t && e && (this.adapter.off(".waypoints"), delete o[this.key]);
  }, e.prototype.createThrottledResizeHandler = function () {
    function t() {
      e.handleResize(), e.didResize = !1;
    }var e = this;this.adapter.on("resize.waypoints", function () {
      e.didResize || (e.didResize = !0, n.requestAnimationFrame(t));
    });
  }, e.prototype.createThrottledScrollHandler = function () {
    function t() {
      e.handleScroll(), e.didScroll = !1;
    }var e = this;this.adapter.on("scroll.waypoints", function () {
      (!e.didScroll || n.isTouch) && (e.didScroll = !0, n.requestAnimationFrame(t));
    });
  }, e.prototype.handleResize = function () {
    n.Context.refreshAll();
  }, e.prototype.handleScroll = function () {
    var t = {},
        e = { horizontal: { newScroll: this.adapter.scrollLeft(), oldScroll: this.oldScroll.x, forward: "right", backward: "left" }, vertical: { newScroll: this.adapter.scrollTop(), oldScroll: this.oldScroll.y, forward: "down", backward: "up" } };for (var i in e) {
      var o = e[i],
          n = o.newScroll > o.oldScroll,
          r = n ? o.forward : o.backward;for (var s in this.waypoints[i]) {
        var a = this.waypoints[i][s],
            l = o.oldScroll < a.triggerPoint,
            h = o.newScroll >= a.triggerPoint,
            p = l && h,
            u = !l && !h;(p || u) && (a.queueTrigger(r), t[a.group.id] = a.group);
      }
    }for (var c in t) {
      t[c].flushTriggers();
    }this.oldScroll = { x: e.horizontal.newScroll, y: e.vertical.newScroll };
  }, e.prototype.innerHeight = function () {
    return this.element == this.element.window ? n.viewportHeight() : this.adapter.innerHeight();
  }, e.prototype.remove = function (t) {
    delete this.waypoints[t.axis][t.key], this.checkEmpty();
  }, e.prototype.innerWidth = function () {
    return this.element == this.element.window ? n.viewportWidth() : this.adapter.innerWidth();
  }, e.prototype.destroy = function () {
    var t = [];for (var e in this.waypoints) {
      for (var i in this.waypoints[e]) {
        t.push(this.waypoints[e][i]);
      }
    }for (var o = 0, n = t.length; n > o; o++) {
      t[o].destroy();
    }
  }, e.prototype.refresh = function () {
    var t,
        e = this.element == this.element.window,
        i = e ? void 0 : this.adapter.offset(),
        o = {};this.handleScroll(), t = { horizontal: { contextOffset: e ? 0 : i.left, contextScroll: e ? 0 : this.oldScroll.x, contextDimension: this.innerWidth(), oldScroll: this.oldScroll.x, forward: "right", backward: "left", offsetProp: "left" }, vertical: { contextOffset: e ? 0 : i.top, contextScroll: e ? 0 : this.oldScroll.y, contextDimension: this.innerHeight(), oldScroll: this.oldScroll.y, forward: "down", backward: "up", offsetProp: "top" } };for (var r in t) {
      var s = t[r];for (var a in this.waypoints[r]) {
        var l,
            h,
            p,
            u,
            c,
            d = this.waypoints[r][a],
            f = d.options.offset,
            w = d.triggerPoint,
            y = 0,
            g = null == w;d.element !== d.element.window && (y = d.adapter.offset()[s.offsetProp]), "function" == typeof f ? f = f.apply(d) : "string" == typeof f && (f = parseFloat(f), d.options.offset.indexOf("%") > -1 && (f = Math.ceil(s.contextDimension * f / 100))), l = s.contextScroll - s.contextOffset, d.triggerPoint = y + l - f, h = w < s.oldScroll, p = d.triggerPoint >= s.oldScroll, u = h && p, c = !h && !p, !g && u ? (d.queueTrigger(s.backward), o[d.group.id] = d.group) : !g && c ? (d.queueTrigger(s.forward), o[d.group.id] = d.group) : g && s.oldScroll >= d.triggerPoint && (d.queueTrigger(s.forward), o[d.group.id] = d.group);
      }
    }return n.requestAnimationFrame(function () {
      for (var t in o) {
        o[t].flushTriggers();
      }
    }), this;
  }, e.findOrCreateByElement = function (t) {
    return e.findByElement(t) || new e(t);
  }, e.refreshAll = function () {
    for (var t in o) {
      o[t].refresh();
    }
  }, e.findByElement = function (t) {
    return o[t.waypointContextKey];
  }, window.onload = function () {
    r && r(), e.refreshAll();
  }, n.requestAnimationFrame = function (e) {
    var i = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || t;i.call(window, e);
  }, n.Context = e;
}(), function () {
  "use strict";
  function t(t, e) {
    return t.triggerPoint - e.triggerPoint;
  }function e(t, e) {
    return e.triggerPoint - t.triggerPoint;
  }function i(t) {
    this.name = t.name, this.axis = t.axis, this.id = this.name + "-" + this.axis, this.waypoints = [], this.clearTriggerQueues(), o[this.axis][this.name] = this;
  }var o = { vertical: {}, horizontal: {} },
      n = window.Waypoint;i.prototype.add = function (t) {
    this.waypoints.push(t);
  }, i.prototype.clearTriggerQueues = function () {
    this.triggerQueues = { up: [], down: [], left: [], right: [] };
  }, i.prototype.flushTriggers = function () {
    for (var i in this.triggerQueues) {
      var o = this.triggerQueues[i],
          n = "up" === i || "left" === i;o.sort(n ? e : t);for (var r = 0, s = o.length; s > r; r += 1) {
        var a = o[r];(a.options.continuous || r === o.length - 1) && a.trigger([i]);
      }
    }this.clearTriggerQueues();
  }, i.prototype.next = function (e) {
    this.waypoints.sort(t);var i = n.Adapter.inArray(e, this.waypoints),
        o = i === this.waypoints.length - 1;return o ? null : this.waypoints[i + 1];
  }, i.prototype.previous = function (e) {
    this.waypoints.sort(t);var i = n.Adapter.inArray(e, this.waypoints);return i ? this.waypoints[i - 1] : null;
  }, i.prototype.queueTrigger = function (t, e) {
    this.triggerQueues[e].push(t);
  }, i.prototype.remove = function (t) {
    var e = n.Adapter.inArray(t, this.waypoints);e > -1 && this.waypoints.splice(e, 1);
  }, i.prototype.first = function () {
    return this.waypoints[0];
  }, i.prototype.last = function () {
    return this.waypoints[this.waypoints.length - 1];
  }, i.findOrCreate = function (t) {
    return o[t.axis][t.name] || new i(t);
  }, n.Group = i;
}(), function () {
  "use strict";
  function t(t) {
    this.$element = e(t);
  }var e = window.jQuery,
      i = window.Waypoint;e.each(["innerHeight", "innerWidth", "off", "offset", "on", "outerHeight", "outerWidth", "scrollLeft", "scrollTop"], function (e, i) {
    t.prototype[i] = function () {
      var t = Array.prototype.slice.call(arguments);return this.$element[i].apply(this.$element, t);
    };
  }), e.each(["extend", "inArray", "isEmptyObject"], function (i, o) {
    t[o] = e[o];
  }), i.adapters.push({ name: "jquery", Adapter: t }), i.Adapter = t;
}(), function () {
  "use strict";
  function t(t) {
    return function () {
      var i = [],
          o = arguments[0];return t.isFunction(arguments[0]) && (o = t.extend({}, arguments[1]), o.handler = arguments[0]), this.each(function () {
        var n = t.extend({}, o, { element: this });"string" == typeof n.context && (n.context = t(this).closest(n.context)[0]), i.push(new e(n));
      }), i;
    };
  }var e = window.Waypoint;window.jQuery && (window.jQuery.fn.waypoint = t(window.jQuery)), window.Zepto && (window.Zepto.fn.waypoint = t(window.Zepto));
}();

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*!
* jquery.countup.js 1.0.3
*
* Copyright 2016, Adrián Guerra Marrero http://agmstudio.io @AGMStudio_io
* Released under the MIT License
*
* Date: Oct 27, 2016
*/
(function ($) {
    "use strict";

    $.fn.countUp = function (options) {

        // Defaults
        var settings = $.extend({
            'time': 2000,
            'delay': 10
        }, options);

        return this.each(function () {

            // Store the object
            var $this = $(this);
            var $settings = settings;

            var counterUpper = function counterUpper() {
                if (!$this.data('counterupTo')) {
                    $this.data('counterupTo', $this.text());
                }
                var time = parseInt($this.data("counter-time")) > 0 ? parseInt($this.data("counter-time")) : $settings.time;
                var delay = parseInt($this.data("counter-delay")) > 0 ? parseInt($this.data("counter-delay")) : $settings.delay;
                var divisions = time / delay;
                var num = $this.data('counterupTo');
                var nums = [num];
                var isComma = /[0-9]+,[0-9]+/.test(num);
                num = num.replace(/,/g, '');
                var isInt = /^[0-9]+$/.test(num);
                var isFloat = /^[0-9]+\.[0-9]+$/.test(num);
                var decimalPlaces = isFloat ? (num.split('.')[1] || []).length : 0;

                // Generate list of incremental numbers to display
                for (var i = divisions; i >= 1; i--) {

                    // Preserve as int if input was int
                    var newNum = parseInt(Math.round(num / divisions * i));

                    // Preserve float if input was float
                    if (isFloat) {
                        newNum = parseFloat(num / divisions * i).toFixed(decimalPlaces);
                    }

                    // Preserve commas if input had commas
                    if (isComma) {
                        while (/(\d+)(\d{3})/.test(newNum.toString())) {
                            newNum = newNum.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
                        }
                    }

                    nums.unshift(newNum);
                }

                $this.data('counterup-nums', nums);
                $this.text('0');

                // Updates the number until we're done
                var f = function f() {
                    $this.text($this.data('counterup-nums').shift());
                    if ($this.data('counterup-nums').length) {
                        setTimeout($this.data('counterup-func'), delay);
                    } else {
                        delete $this.data('counterup-nums');
                        $this.data('counterup-nums', nums);
                        $this.data('counterup-func', null);
                    }
                };
                $this.data('counterup-func', f);

                // Start the count up
                setTimeout($this.data('counterup-func'), delay);
            };

            // Perform counts when the element gets into view
            $this.waypoint(counterUpper, { offset: '100%', triggerOnce: true });
        });
    };
})(jQuery);

/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _api = __webpack_require__(0);

var type = 0;
$(function () {
    var url = $('body').attr('pageType');
    var registerButton = $('.home-header-right > button:last-child'); //注册的按钮
    var loginButton = $('.home-header-right > button:first-child'); //获取登陆的按钮
    var MenuCount = $('.home-header-center');
    // console.log([0]);

    function skipPage() {
        if (url === 'index') {
            MenuCount.find(' > div:nth-child(1)').addClass('header-center-active');
        } else if (url === 'information') {
            $('.header-center-active').removeClass('header-center-active');
            MenuCount.find(' > div:nth-child(2)').addClass('header-center-active');
        } else if (url === 'intelligentReach' || url === 'CRM' || url === 'AIskill' || url === 'tokeClue') {
            $('.header-center-active').removeClass('header-center-active');
            MenuCount.find(' > div:nth-child(3)').addClass('header-center-active');
        } else if (url === 'channel') {
            $('.header-center-active').removeClass('header-center-active');
            MenuCount.find(' > div:nth-child(4)').addClass('header-center-active');
        } else if (url === 'case') {
            $('.header-center-active').removeClass('header-center-active');
            MenuCount.find(' > div:nth-child(5)').addClass('header-center-active');
        } else if (url === 'about') {
            $('.header-center-active').removeClass('header-center-active');
            MenuCount.find(' > div:nth-child(6)').addClass('header-center-active');
        } else if (url === 'new') {
            $('.header-center-active').removeClass('header-center-active');
            MenuCount.find(' > div:nth-child(7)').addClass('header-center-active');
        }
    }
    skipPage();

    $('.classify-product-title').mouseenter(function () {
        $('.classify-product-active').removeClass('classify-product-active');
        $(this).addClass('classify-product-active');
    });

    registerButton.click(function () {
        window.open('register.html', "_blank");
    });

    loginButton.click(function () {
        window.open('' + _api.LOGINURLBASE, "_blank");
    });

    function fadeIn() {
        $("#category").css("display", "block");
        // $("#category").css("opacity","0");
        $(".category").removeClass("fadeout").addClass("fadein");
    }

    function fadeOut() {
        $(".category").removeClass("fadein").addClass("fadeout");
        setInterval(function () {
            if ($('.fadeout').css("opacity") == 0) {
                $("#category").css("display", "none");
            }
        }, 100);
    }

    $(".product-menu").mouseenter(function () {
        fadeIn();
        $("body").css("overflow", "hidden");
        $(".product-menu > span:nth-child(2)").css("display", "none");
        $(".product-menu > span:nth-child(3)").css("display", "block");
    });

    $(".product-menu").mouseleave(function () {
        fadeOut();
        $("body").css("overflow", "auto");
        $(".product-menu > span:nth-child(2)").css("display", "block");
        $(".product-menu > span:nth-child(3)").css("display", "none");
    });

    $(".jump-login").on("click", function () {
        window.open('' + _api.BASEURL, "_blank");
    });
});

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _api = __webpack_require__(0);

$(function () {
    $(".customer-login").click(function () {
        window.open("" + _api.LOGINURLBASE, "_blank");
    });

    $(".serviceCompany").on("click", function () {
        window.open("" + _api.CREURL, "_blank");
    });
});

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

!function (e, t, a) {
  function n(e) {
    return Object.prototype.toString.call(e).toLocaleLowerCase().replace(/[\[\]]/g, "").split(" ")[1];
  }if (!t) return void console.error("lack jQuery.js");var i = { info: function info(e) {
      var t = this._getConf(e);return t.icon = '<i class="fa fa-exclamation-circle vt-icon vt-info" aria-hidden="true"></i>', t.background = "info", this._make(t);
    }, error: function error(e) {
      var t = this._getConf(e);return t.icon = '<i class="fa fa-times-circle vt-icon vt-error" aria-hidden="true"></i>', t.background = "error", this._make(t);
    }, success: function success(e) {
      var t = this._getConf(e);return t.icon = '<i class="fa fa-check-circle vt-icon vt-success" aria-hidden="true"></i>', t.background = "success", this._make(t);
    }, warning: function warning(e) {
      var t = this._getConf(e);return t.icon = '<i class="fa fa-exclamation-circle vt-icon vt-warning" aria-hidden="true"></i>', t.background = "warning", this._make(t);
    }, panel: function panel(e) {
      return "object" != n(e) && (e = { content: e }), e = Object.assign({}, { closable: !0, duration: 0, style: { minWidth: 320 } }, e), this._make(this._getConf(e));
    }, _getConf: function _getConf(e) {
      var t = Object.assign({}, this._config);return e && "object" == n(e) ? Object.assign(t, e) : e ? Object.assign(t, { content: e }) : t;
    }, _getId: function _getId() {
      return "VtMessageId_" + Math.floor(1e7 * Math.random());
    }, _config: { duration: 2500, background: !1, color: null, content: "", onclose: null, icon: "", animate_duration: 500, closable: !1, header: !1, title: !1, footer: !1, confirm: function confirm(e) {
        e();
      }, confirm_text: "确认", cancel: function cancel(e) {
        e();
      }, cancel_text: "取消", area: [], mask: !1, parent: null, remove_parent: !1, offset: "vt-right-top", style: null }, _createHeader: function _createHeader(e, a) {
      if (a.header) {
        var n = t('<div class="vt-message-header">' + (a.icon + a.header) + "</div>");e.prepend(n);
      } else if (a.title) {
        var i = t('<div class="vt-message-header"><div class="vt-header-text">' + (a.icon + a.title) + "</div></div>");e.prepend(i);
      }this._createClose(e, e.find(".vt-message-header"), a);
    }, _createClose: function _createClose(e, a, n) {
      var i = this;if (n.closable && a.length) {
        var s = t('<div class="vt-hide"><i class="fa fa-times" aria-hidden="true"></i></div>');a.append(s), s.find("i").bind("click", function () {
          i.hide(e, n);
        });
      }
    }, _createContent: function _createContent(e, a) {
      var n = a.header || a.title || !a.icon ? "" : a.icon;n += a.content;var i = t('<div class="vt-message-body">' + n + "</div>");a.header || a.title || !a.closable || this._createClose(e, i, a), e.append(i);
    }, _createFooter: function _createFooter(e, a) {
      var i = this;if (a.footer && "string" == n(a.footer)) e.append('<div class="vt-message-footer">${conf.footer}</div>');else if ((a.cancel || a.confirm) && a.footer) {
        var s = t('<div class="vt-message-footer"></div>');if (e.append(s), a.cancel) {
          var o = t('<button class="vt-cancel">' + a.cancel_text + "</button>");s.append(o), o.on("click", function () {
            !0 === a.cancel(function () {
              i.hide(e, a);
            }) && i.hide(e, a);
          });
        }if (a.confirm) {
          var r = t('<button class="vt-confirm">' + a.confirm_text + "</button>");s.append(r), r.on("click", function () {
            !0 === a.confirm(function () {
              i.hide(e, a);
            }) && i.hide(e, a);
          });
        }
      }
    }, _setMask: function _setMask(e, t) {
      if (t.mask) {
        var a = Math.floor(1e6 * Math.random());e.parent().addClass("vt-message-mask").data("mask", a), e.data("mask", a);
      }
    }, hide: function hide(e, t) {
      e.data("mask") && e.parent().data("mask") && e.data("mask").toString() == e.parent().data("mask").toString() && e.parent().removeClass("vt-message-mask").data("mask", "0"), e.addClass("vt-remove");var a = function a() {
        t.remove_parent && e.parent().remove(), e.remove();
      };t.onclose ? t.onclose(a, e, t) : setTimeout(a, t.animate_duration);
    }, _make: function _make(e) {
      var a = this,
          i = this._getId(),
          s = t('<div class="vt-message"  id="' + i + '"></div>');return this.getContainer(e).append(s), e.class && s.addClass(e.class), e.color && s.css("color", e.color), e.background && (/^(#|rgb\(|rgba\()/.test(e.background) ? s.css("background-color", e.background) : s.addClass("vt-background vt-bg-" + e.background)), e.style && "object" == n(e.style) && s.css(e.style), this._createHeader(s, e), this._createContent(s, e), this._createFooter(s, e), e.area.length > 0 && s.css("width", e.area[0]), e.area.length > 1 && s.css("height", e.area[1]), this._setMask(s, e), e.offset && ("string" == n(e.offset) ? s.addClass(e.offset) : s.css("position", "absolute").css(e.offset)), e.duration > 0 && setTimeout(function () {
        a.hide(s, e);
      }, e.duration), s;
    }, getContainer: function getContainer(e) {
      var a = t(e.parent ? e.parent : ".vt-message-package");return a.length || (a = t('<div class="vt-message-package"></div>'), t(document.body).append(a)), a;
    } };a && (a.Message = i), e.VtMessage = i;
}(window, window.jQuery, window.ViewT);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/common.98a2fa.js